function productGridFirst(element){
    setTimeout(() => {
        //matchHeightImageRender1x();
        //matchHeightImageRender2x();
    }, 100);
    var collectionGridContainer = document.querySelector('.product-grid-container');
    var collectionGrid = document.querySelector('.collections-grid');
    var collectionGridRelated = document.querySelectorAll('.Container-collectionGrid-related ul');
    var firstProductGrid = collectionGrid.getAttribute("grid-productsFirst");
    var secondProductGrid = collectionGrid.getAttribute("grid-productsSecond");
    var secondGridButton = document.querySelector('.productGridSecond');
    element.classList.add("collection-productGrid--active");
    secondGridButton.classList.remove("collection-productGrid--active");
    collectionGrid.classList.add(`collections-grid--${firstProductGrid}`);
    collectionGrid.classList.remove(`collections-grid--${secondProductGrid}`);
    collectionGridContainer.classList.add('product-grid-container--1');
    collectionGridContainer.classList.remove('product-grid-container--2');

    console.log('collectionGridRelated2', collectionGridRelated);

    collectionGridRelated.forEach(function(element) {
        element.classList.add(`collections-grid--${firstProductGrid}`);
        element.classList.remove(`collections-grid--${secondProductGrid}`);
    });  
}

function productGridSecond(element){
    setTimeout(() => {
        //matchHeightImageRender1x();
        //matchHeightImageRender2x();
    }, 100);
    var collectionGridContainer = document.querySelector('.product-grid-container');
    var collectionGrid = document.querySelector('.collections-grid');
    var collectionGridRelated = document.querySelectorAll('.Container-collectionGrid-related ul');
    var firstProductGrid = collectionGrid.getAttribute("grid-productsFirst");
    var secondProductGrid = collectionGrid.getAttribute("grid-productsSecond");
    var firstGridButton = document.querySelector('.productGridFirst');
    element.classList.add("collection-productGrid--active");
    firstGridButton.classList.remove("collection-productGrid--active");
    collectionGrid.classList.add(`collections-grid--${secondProductGrid}`);
    collectionGrid.classList.remove(`collections-grid--${firstProductGrid}`);
    collectionGridContainer.classList.remove('product-grid-container--1');
    collectionGridContainer.classList.add('product-grid-container--2');

    collectionGridRelated.forEach(function(element) {
        element.classList.add(`collections-grid--${secondProductGrid}`);
        element.classList.remove(`collections-grid--${firstProductGrid}`);
    });
}